exports = module.exports = require("../../../../node_modules/fast-css-loader/lib/css-base.js")(false);
// imports

// module
exports.push([module.id, "@media (min-width: 58.8125em) {\n  #main.layout-landing main {\n    --max-content-width: 94rem; } }\n", ""])